import { useKidContext } from "../layout";
import { BadgeShowcase } from "@/components/kid/badge-showcase";

export default function KidBadgesPage() {
  const { childId } = useKidContext();
  return <BadgeShowcase childId={childId} />;
}
